import React from 'react';

import { useParams } from 'react-router-dom';

import { Dialog, DialogContent, DialogTitle } from '@mui/material';

import BundleItemForm from './components/BundleItemForm';

function BundlesItemCreate() {
  const { bundleId } = useParams<{ bundleId: string }>();

  return (
    <Dialog open maxWidth="sm" fullWidth>
      <DialogTitle>Create Bundle Item</DialogTitle>
      <DialogContent>
        <BundleItemForm bundleId={bundleId} />
      </DialogContent>
    </Dialog>
  );
}

export default BundlesItemCreate;
